import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrud = () => import('./staff/crud')
const ViewStaffView = () => import('./staff/view')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'SuppliersDashboardStaff',
  crud: 'SuppliersListStaff',
  view: 'SuppliersViewStaff',
}

const router =
  [
    {
      path: '/st/suppliers',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Proveedores',
          }                        
        },  
        {
          path: 'suppliers',
          name: VIEWS.crud,
          component: ViewStaffCrud,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Listado Proveedores',
          }                        
        },       
        {
          path: 'suppliers/:suppliersID/view',
          name: VIEWS.view,
          component: ViewStaffView,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Vista Proveedor',
          }                        
        },
      ]
    },

    {
      path: '/cu/suppliers',
      component: DefaultContainer,
      children: [
        
      ]
    },  

    
    {
      path: '/su/suppliers',
      component: DefaultContainer,
      children: [
        
      ]
    },  
  ]

export default router
export { VIEWS }
